import { useDispatch, useSelector } from "react-redux";
import { updateUserProfile } from "@/state/profileSlice";
import { TranslatedText } from "@/components/common/text";
import { trailerTypes } from "@/utils/constants";
import { cn } from "@/utils/css";

export const TrailerTypeChips = () => {
    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();
    const selectedId = profile.data?.trailerType?.id;

    return (
        <div className="flex flex-1 flex-wrap gap-2">
            {trailerTypes.map((trailerType) => {
                const selected = trailerType.id === selectedId;
                return (
                    <button
                        key={trailerType.id}
                        type="button"
                        disabled={profile.loading || !profile.data}
                        aria-pressed={selected}
                        onClick={() => !selected && dispatch(updateUserProfile({ ...profile.data, trailerType }))}
                        className={cn(
                            "inline-flex h-6 items-center justify-center rounded-full border px-2.5 text-xs font-medium uppercase",
                            selected
                                ? "border-cm-p-accent-400 bg-cm-p-container-green text-cm-p-on-container-green"
                                : "border-transparent bg-cm-p-surface-container text-cm-p-text-primary hover:bg-cm-p-surface-container-hover",
                        )}
                    >
                        <TranslatedText>{trailerType.text}</TranslatedText>
                    </button>
                );
            })}
        </div>
    );
};
